import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'custom-form-field',
  templateUrl: './form-field.component.html',
})
export class FormFieldWrapperComponent extends FieldWrapper {
  override defaultOptions = {
    props: {
      localize: true,
    },
  };
}
